module.exports = __webpack_public_path__ + "static/img/app07.5de6b55.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app07.png
// module id = GAdF
// module chunks = 1